<template>
  <div class="trygame-box">
    <van-nav-bar
      right-text="规则"
      left-arrow
      fixed
      safe-area-inset-top
      id="nav-topp"
    >
      <template #left>
        <img
          src="../../assets/nav/yz_nav_fh_w.png"
          alt=""
          @click="onClickLeft"
        />
      </template>
      <template #right>
        <span @click="goGetRecord">任务记录 </span>
        &nbsp;|&nbsp;
        <span @click="onClickRight"> 规则</span>
      </template>
    </van-nav-bar>
    <div class="trygame-content">
      <div class="tips-box">
        <img src="../../assets/task/task_tips1.png" alt="" />
        <img src="../../assets/task/task_tips2.png" alt="" />
      </div>

      <van-pull-refresh v-model="state.refresh" @refresh="onRefresh">
        <div class="task-list">
          <div class="hot">
            <van-list
              v-model:loading="state.loading"
              :finished="state.finished"
              finished-text="没有更多了"
              @load="onLoad"
            >
              <van-cell
                v-for="(item, i) in state.hotlist"
                :key="i + '-hotlist'"
              >
                <template #value>
                  <div class="task-item-big">
                    <div class="task-item">
                      <div class="task-left">
                        <img
                          :src="item.pic ? item.pic : state.noimg"
                          @click="goGame(item.gameid)"
                        />
                        <van-button
                          v-if="item.finished === '-2'"
                          round
                          type="primary"
                          size="small"
                          color="#FF6666"
                        >
                          已结束
                        </van-button>
                        <van-button
                          v-else-if="item.finished === '-1'"
                          round
                          type="primary"
                          size="small"
                          color="#454256"
                          @click.stop="recievTask(item)"
                        >
                          领任务
                        </van-button>
                        <van-button
                          v-else-if="item.finished == '0'"
                          round
                          type="primary"
                          size="small"
                          color="#FFFFFF"
                          class="ingBtn"
                        >
                          进行中
                        </van-button>
                        <van-button
                          v-else-if="item.finished == '-4'"
                          round
                          type="primary"
                          size="small"
                          color="#454356"
                        >
                          未开始
                        </van-button>
                        <van-button
                          v-else-if="item.finished === '1'"
                          round
                          type="primary"
                          size="small"
                          color="#00D9C3"
                          @click.stop="recievGold(item.tid)"
                        >
                          领奖励
                        </van-button>
                        <van-button
                          v-else-if="item.finished === '2'"
                          round
                          type="primary"
                          size="small"
                          color="#454356"
                        >
                          已完成
                        </van-button>

                        <span
                          v-else-if="item.finished === '-9'"
                          class="StatusBox"
                        >
                          名额已满
                        </span>
                        <span
                          v-else-if="item.finished === '-8'"
                          class="StatusBox"
                        >
                          已有其他账号领取
                        </span>
                      </div>
                      <div class="task-info">
                        <h3>{{ item.title }}</h3>
                        <div>
                          <span class="discount" v-if="item.firstpay != 1">
                            {{ handleDiscount(item.firstpay) }}折
                          </span>
                          <span class="type_word">{{ item.cellAbstract }}</span>
                          <p>
                            <img
                              src="../../assets/task/task_money_icon.png"
                              alt=""
                            />
                            {{ item.integral }}{{ item.reward_method }}
                          </p>
                        </div>
                        <p>
                          试玩至<span>
                            {{ item.level }}{{ item.task_describe }}
                          </span>
                          领奖
                        </p>
                        <p>
                          {{ item.timeString }}（剩余:
                          {{ item.limited - item.people }}）
                        </p>
                      </div>
                    </div>
                  </div>
                </template>
              </van-cell>
            </van-list>
          </div>
        </div>
      </van-pull-refresh>
    </div>
    <van-popup v-model:show="state.popShow" class="game_pop">
      <img :src="state.getGame.pic" alt="" />
      <h4>{{ state.getGame.gamename }}</h4>
      <button @click="goGame(state.getGame.gameid)">去游戏</button>
    </van-popup>
  </div>
</template>

<script>
import { reactive, computed, onMounted, onUnmounted, onActivated } from "vue";
import { useRouter } from "vue-router";
import { Toast } from "vant";
// import { Trial, achieveTrial,getTrial,achieveTrialFlb } from "@/api/task";

import { Trial, getTrial, achieveTrial } from "@/api/task";
import { useStore } from "vuex";
import { dateMD } from "@/utils/date";
import { detect } from "@/utils/device";
import defaultimg1 from "@/assets/defaultimg/error2.png";
import { getQueryString } from "../../utils/location";
import { setToken, getToken, removeToken } from "@/utils/auth";
import { handleDiscount } from "@/utils/tool";

export default {
  name: "trygame",
  setup() {
    const router = useRouter();
    const store = useStore();
    const state = reactive({
      noimg: defaultimg1,
      num: "0",
      taskstatus: "1",
      newlist: [],
      hotlist: [],
      refresh: false,
      loading: false,
      finished: false,
      showNewList: false,
      nowpage: 1,
      trygamelist: [],
      gameid: "",
      popShow: false,

      getGame: {
        img: "",
        title: "",
        gid: 0,
      },
    });
    onUnmounted(() => {
      window.removeEventListener("scroll", onScrollCard);
    }),
      onMounted(() => {
        if (getQueryString("token")) {
          setToken(getQueryString("token"));
        }
        scrollTo(0, 0);
        window.addEventListener("scroll", onScrollCard);

        if (getQueryString("gameid")) {
          state.gameid = getQueryString("gameid");
        }
      });
    const onScrollCard = () => {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var oDiv = window.document.getElementById("nav-topp"); //获取DOM元素对象
      if (scrollTop <= 100) {
        var alpha = parseInt((scrollTop / 100) * 255).toString(16);
        if (alpha < 77) {
          alpha = "00";
        }
        oDiv.style.backgroundColor = "#12CEC7" + alpha; //设置fierfox等透明度，注意透明度值是小数
      } else {
        oDiv.style.backgroundColor = "#12CEC7" + "FF";
      }
    };

    // 试玩列表数据
    const taskTrial = async (pagecode) => {
      if (pagecode == 1) {
        state.newlist = [];
        state.hotlist = [];
        state.trygamelist = [];
      }
      let totalPage;
      let type;
      if (detect() == "ios") {
        type = "ios";
      } else {
        type = "an";
      }
      await Trial({
        type: "an",
        uid: getQueryString("uid"),
        page: pagecode,
        gameid: state.gameid,
      }).then((response) => {
        // console.log('新游试玩返回的试玩游戏数据----------------', response.data)
        if (response.data.code == "1") {
          // 首发新游
          state.num = response.data.data.People;
          state.newlist = response.data.data.Starting;
          // 精品热游
          let list = response.data.data.aa[1];

          // let list = response.data.data.Starting;
          totalPage = response.data.data.totalPage;
          state.hotlist = state.hotlist.concat(list);
          // 加载状态结束
          state.loading = false;
          // 数据全部加载完成
          if (pagecode >= totalPage) {
            state.finished = true;
          }
          // 页数加一
          state.nowpage++;
        } else {
          Toast(response.data.msg);
        }
      });
    };

    // 时间戳转换
    const time = computed(() => {
      return function(date) {
        return dateMD(date);
      };
    });

    // 返回
    const onClickLeft = () => {
      // router.back();
      window.document.location = "goBack://";
    };

    // 记录
    const onClickRight = () => {
      var url = "https://abc.5535.cn/public/swtask/index.html";
      router.push({
        path: "/newpublic/webActivity",
        query: {
          url: url,
          title: "试玩规则",
        },
      });
    };

    // 跳转游戏
    const goGame = (tid) => {
      state.popShow = false;
      window.document.location = "gogame://" + tid;
    };
    // 进入任务详情
    const goDetails = (tid) => {
      router.push({
        path: "/personal-page/trygame/details",
        query: { tid: tid },
      });
    };

    // 领取任务奖励
    let fetchFlag = false;
    const recievGold = (tid) => {
      if (fetchFlag) return;
      fetchFlag = true;
      achieveTrial({
        tid: tid,
        // uid: store.state.id,
        uid: getQueryString("uid"),
      }).then((response) => {
        fetchFlag = false;
        // console.log('领取任务奖励返回的数据----------------', response.data)
        if (response.data.code == 1) {
          taskTrial(1);
          Toast(response.data.msg);
        } else {
          Toast(response.data.msg);
        }
      });
      onnLoad();
    };

    // 领取任务
    const recievTask = async (data) => {
      await getTrial({
        tid: data.tid,
        uid: getQueryString("uid"),
      }).then((response) => {
        // console.log('领取任务返回的数据----------------', response.data)
        if (response.data.code == 1) {
          taskTrial(1);
          state.getGame = data;
          state.popShow = true;
        } else {
          Toast(response.data.msg);
        }
      });
    };

    // let pagecode = 1;
    // 加载试玩数据
    const onLoad = () => {
      // 异步更新数据
      taskTrial(state.nowpage);
    };

    const onRefresh = () => {
      // location.reload()
      setTimeout(() => {
        state.refresh = false;
        state.nowpage = 1;
        state.loading = true;
        state.finished = false;
        taskTrial(1);
      }, 1000);

      // state.finished = false;
      // state.loading = false;
      // state.refresh = false;
      // state.nowpage = 1;
      // taskTrial(state.nowpage);
    };

    // 领奖记录
    const goGetRecord = () => {
      router.push({
        path: "/newTrygame/record",
        query: { username: getQueryString("username") },
      });
    };
    return {
      state,
      onClickLeft,
      onClickRight,
      onLoad,
      recievGold,
      goDetails,
      time,
      goGame,
      recievTask,
      onRefresh,
      handleDiscount,
      goGetRecord,
    };
  },
};
</script>

<style scoped src="../../styles/removeVantcell.css"></style>
<style scoped="scoped">
::v-deep .van-nav-bar__text {
  color: #fff;
}
::v-deep .van-nav-bar__right {
  color: #fff;
}
.van-nav-bar {
  background: none;
  padding-top: calc(60px + constant(safe-area-inset-top));
  padding-top: calc(60px + env(safe-area-inset-top));
}

.van-hairline--bottom:after {
  border-bottom-width: 0;
}

.van-button {
  width: 112px;
  height: 66px;
  line-height: 66px;
  vertical-align: middle;
  font-size: 24px;
  font-family: PingFang SC-Medium;
  margin-bottom: 24px;
  margin-top: 16px;
  /* position: absolute;
  top: 4px;
  right: 4px; */
}

.trygame-box {
  background-color: #30a6e6;
  height: 100vh;
  overflow: auto;
}

.trygame-content {
  background-color: #1a1a26;
  min-height: 100vh;
}

.tips-box {
  background: #1a1a26 url(../../assets/task/task_head_bg.png) no-repeat center;
  background-size: 100% 100%;
  height: 582px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding-top: 56px;
}
.tips-box img:nth-of-type(1) {
  width: 508px;
  height: 200px;
  margin-bottom: 48px;
}
.tips-box img:nth-of-type(2) {
  width: 686px;
  height: 75px;
}

.hot {
  margin-top: 30px;
}

.task-list {
  margin-top: 30px;
  margin-left: 30px;
  margin-right: 30px;
}

.task-list h3 {
  font-size: 32px;
  color: #333;
}

.task-list h3 span {
  font-size: 20px;
  color: #999;
  margin-left: 20px;
}

.task-item-big {
  background: #fff;
  padding: 20px;
  border-radius: 32px;
  margin-top: 20px;
}

.task-item {
  display: flex;
  position: relative;
}
.task-item .task-left {
  width: 224px;
  height: 290px;
  display: flex;
  flex-direction: column;
  background: url(../../assets/task/task_left_bg.png) no-repeat;
  background-size: 100% 100%;
  border-radius: 20px 20px 20px 20px;
  flex-shrink: 0;
  align-items: center;
  padding: 24px 25px 0 0;
}
.task-item .task-left img {
  width: 160px;
  height: 160px;
  border: 4px solid #ffffff;
  border-radius: 30px;
}

.task-item .task-info {
  padding-left: 12px;
  width: 100%;
  flex: 1;
  font-size: 24px;
}

.task-item .task-info h3 {
  font-size: 32px;
  color: #333;
  width: 410px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-bottom: 12px;
}

.task-item .task-info p img {
  width: 32px;
  height: 32px;
  margin-right: 4px;
}

.task-item .task-info > div {
  display: flex;
  margin: 12px 0;
}
.task-item .task-info > div > p {
  background-color: #fff8ee;
  height: 42px;
  padding: 0 10px;
  font-size: 24px;
  color: #f99a11;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  border-radius: 10px;
}
.task-item .task-info > div > span {
  margin-right: 8px;
}
.task-info > div span {
  height: 42px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  font-size: 24px;
}
.task-info > div .discount {
  background: linear-gradient(270deg, #21c1e0 0%, #01d8c4 100%);
  color: #fff;
  font-weight: 600;
}
.task-info > div .type_word {
  background-color: #f5f6fa;
  color: #666666;
}

.task-item .task-info > p {
  color: #999;
  height: 74px;
  width: 410px;
  background-color: #f5f6fa;
  border-radius: 20px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  padding-left: 20px;
  font-size: 20px;
}
.task-item .task-info > p:nth-of-type(1) {
  font-size: 24px;
  color: #111111;
}
.task-item .task-info > p:nth-of-type(1) span {
  color: #00d9c3;
}
.task-item .task-info > span {
  color: #00d9c3;
}

.taskInfo {
  background-color: #f1f1f1;
  border-radius: 8px;
  padding: 16px;
  color: #8f9197;
  font-size: 24px;
  margin-top: 24px;
}

.taskInfo span {
  color: #8f9197;
  font-family: PingFang SC-Medium;
}

.StatusBox {
  width: 100px;
  height: 48px;
  line-break: auto;
  color: #454256;
  font-size: 20px;
  margin-top: 30px;
  font-size: 24px;
}

.goldlabel {
  color: #999;
  margin-top: 24px;
  font-size: 20px;
}
.van-nav-bar__left img {
  width: 60px;
  height: 60px;
}
.ingBtn {
  color: #12cec7 !important;
}

.trygame-box :deep(.game_pop) {
  width: 634px;
  height: 742px;
  background: url(../../assets/task/task_pop_bg.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  padding-top: 80px;
  font-size: 32px;
}
.trygame-box :deep(.game_pop) img {
  width: 200px;
  height: 200px;
}
.trygame-box :deep(.game_pop) h4 {
  margin: 40px 0 78px 0;
}
.trygame-box :deep(.game_pop) button {
  width: 434px;
  height: 92px;
  background: #4c5793;
  border-radius: 198px 198px 198px 198px;
  border: none;
  font-size: 28px;
}
</style>
